const PAYMENTS_USERS = new Set([
  '7d7c9786-9716-400e-82eb-3091e8c677bf', // tobias@vesterlund.se
  '30e60d69-bd23-4198-a9f6-07b3324d801a', // mrkevbrown2@gmail.com
  '59b36d05-27a9-4ed2-b960-aa8411a393ef', // mj@afripods.com
  'e0ab7860-f4ba-404f-b87b-f3ae49ebe289', // lilly@selamandhello.com
  '43b6d0ca-1fc6-48ba-80ad-618a8ed71a9e', // yesgirlspodcast@gmail.com
  '34417b5f-ee7f-4c6f-b453-9b229b87c1f7', // machuangela@gmail.com
  'ff93d6bb-1716-4faf-ba4e-3f5f115f36b0', // bookingkevinybrown@gmail.com
])

export default function isAuthorizedPaymentsUser(userId) {
  return PAYMENTS_USERS.has(userId)
}



// WEBPACK FOOTER //
// ./src/utils/payments-users.js